export const environment = {
  baseUrl: 'https://api.dev.blackcat.roocket.io/api',
  gApiKey: 'AIzaSyAi2Eoxn5FxKUzBtzLiTtFmyXo8i04yc3Y'
};
